import angular from 'angular';
import uiRouter from 'angular-ui-router';
import trainerProfile from './trainerProfile.component';

let trainerProfileModule = angular.module('trainerProfile', [
	uiRouter,
]).config(($stateProvider) =>{
	'ngInject';

	$stateProvider.state('trainer-profile', {
		url: '/trainers/{id}/profile',
		component: 'trainerProfile',
		data: {pageTitle: 'TRAINER_PROFILE'}
	});

}).component('trainerProfile', trainerProfile).name;

export default trainerProfileModule;



// WEBPACK FOOTER //
// ./client/app/components/trainers/trainerProfile/trainerProfile.js